import { createContext } from "react";
import {
  ComplianceProgramPerformanceReportRowFragment,
  GetComplianceProgramForReportQuery,
} from "types/graphql-schema";
import { BasicUser } from "types/topicflow";

import { initAssessmentReportViewOptions } from "../components/assessment-report/helpers";
import { ChartLabel } from "../components/assessment-report/nine-box/types";
import { AssessmentReportViewOptions } from "../components/assessment-report/report-filters/types";

type PerformanceAssessmentReportContextType = {
  complianceProgramId: number;
  complianceProgram?: GetComplianceProgramForReportQuery["complianceProgram"];
  chartLabels: ChartLabel[];
  viewOptions: AssessmentReportViewOptions;
  calibrationGroups: {
    data: {
      id: number;
      name: string;
      users: BasicUser[];
      managers: BasicUser[];
      approvers: BasicUser[];
    }[];
    showColumn: boolean;
  };
  userRows: ComplianceProgramPerformanceReportRowFragment[];
};

const PerformanceAssessmentReportContext =
  createContext<PerformanceAssessmentReportContextType>({
    complianceProgramId: -1,
    complianceProgram: undefined,
    chartLabels: [],
    viewOptions: initAssessmentReportViewOptions,
    calibrationGroups: {
      showColumn: false,
      data: [],
    },
    userRows: [],
  });

export default PerformanceAssessmentReportContext;
